let API_BASE_URL;
if (process.env.REACT_APP_API_URL) {
  API_BASE_URL = process.env.REACT_APP_API_URL;
} else if (process.env.NODE_ENV === 'production') {
  API_BASE_URL = 'https://api.tulidu-wallet.com';
} else {
  API_BASE_URL = 'http://localhost:4001';
}

export const apiConfig = {
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
};

export default apiConfig; 